import CircularProgress from '@mui/material/CircularProgress'
import { CONSTS } from 'config/objectConst.js'
import { workspaceApi, WorkSpaceUI, workspaceUtils } from 'features/workspace'
import { useRef } from 'react'
import { Link } from 'react-router-dom'
import { useAppSelector } from 'shared/hooks/index.ts'
import { useSyncPopoverState } from 'shared/hooks/useSyncPopoverState.ts'
import { typo } from 'shared/styles'
import { Button, StackIcon } from 'shared/ui'

import LinkedInBlock from '../../atoms/LinkedInBlock/index.js'
import { LogOut } from './LogOut.tsx'
import css from './UserHeaderWidget.module.scss'

/*
	? Refetch statistics on open popover
*/

export function DropDownMenu() {
	const popoverRef = useRef<HTMLDivElement | null>(null)
	const close = () => popoverRef.current?.hidePopover()
	const isOpen = useSyncPopoverState(popoverRef)

	return (
		<div
			className={`${css.popover} drop-down-menu profile-menu`}
			id='header-user-menu'
			// @ts-ignore Recheck in React 19
			popover='auto'
			ref={popoverRef}
		>
			<Button as={Link} onClick={close} to='/account' variant='bordered-dark'>
				<StackIcon icon='user' width={18} />
				Go to account
			</Button>

			<hr className={css.line} />

			<LinkedInBlock />

			<hr className={css.line} />

			{isOpen && <Stats />}

			<hr className={css.line} />
			<LogOut />

			<hr className={css.line} />
			<footer className={`${css.footer} ${typo.caption}`}>
				<a
					href={CONSTS.TERMS_AND_CONDITIONS_URL}
					rel='noopener noreferrer'
					target='_blank'
				>
					Terms of use
				</a>

				<a
					href={CONSTS.PRIVACY_POLICY}
					rel='noopener noreferrer'
					target='_blank'
				>
					Privacy policy
				</a>
			</footer>
		</div>
	)
}

function Stats() {
	const rangeState = useAppSelector(workspaceUtils.selectCurrentDay)
	const { data: statistics, isFetching } = workspaceApi.useStatisticsQuery(
		rangeState,
		{
			refetchOnMountOrArgChange: true
		}
	)

	return (
		<div>
			<h4 className={typo.buttonSmB}>
				Performed today:{' '}
				{isFetching && (
					<CircularProgress
						classes={{ colorPrimary: 'material-loader' }}
						color='primary'
						size={'1em'}
					/>
				)}
			</h4>
			<WorkSpaceUI.Performed limit statistics={statistics} />
		</div>
	)
}
